<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        รายงานร้อยละของจำนวนรายการส่งเสริมการขายตามจริงเป็นวินาทีและนาทีของแต่ละผู้ให้บริการ
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <router-link to="/Admin/Promotion_percent">
            <i class="fa fa-dashboard"></i> รายงานร้อยละของจำนวนรายการส่งเสริมการขายตามจริงเป็นวินาทีและนาทีของแต่ละผู้ให้บริการ
          </router-link>
        </li>
      </ol>
    </section>
    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="150px"
                      :model="form"
                      ref="ruleForm"
                      class="demo-ruleForm"
                    >
                      <div class="col-sm-12">
                        <div class="col-sm-6">
                          <el-form-item label="ประเภทรายงาน" required>
                            <el-select
                              ref="type_report"
                              v-model="form.type_report"
                              @change="clear_data"
                            >
                              <!-- <el-option label="รายเดือน" value="month"></el-option> -->
                              <el-option label="ระหว่างเดือน" value="between_month"></el-option>
                              <el-option label="รายปี" value="year"></el-option>
                              <el-option label="ระหว่างปี" value="between_year"></el-option>
                              <el-option label="ไตรมาส" value="quarter"></el-option>
                              <el-option label="ช่วงไตรมาส" value="between_quarter"></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="ประเภทผู้ให้บริการ">
                            <el-radio-group v-model="form.type_providers" @change="switch_type">
                              <el-radio label="group">กลุ่มผู้ให้บริการ</el-radio>
                              <el-radio label="provider">รายชื่อผู้ให้บริการ</el-radio>
                            </el-radio-group>
                          </el-form-item>
                          <el-form-item label="กลุ่มผู้ให้บริการ" :required="form.type_providers == 'group'">
                            <el-radio-group v-model="form.provider_group"  :disabled="!(form.type_providers == 'group')" >
                              <el-radio v-for="item in this.store_groups" :key="item.id" :label="item.id">{{ item.group_name_th}}</el-radio>
                            </el-radio-group>
                          </el-form-item>
                          <el-form-item label="รายชื่อผู้ให้บริการ" :required="form.type_providers == 'provider'">
                            <el-radio-group v-model="form.provider_list" :disabled="!(form.type_providers == 'provider')"  >
                              <el-radio v-for="item in this.store_providers" :key="item.id" :label="item.id" >{{ item.brand_name}}</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item
                            label="กรุณาเลือกประเภทรายงาน"
                            v-if="form.type_report === ''"
                          >
                            <el-input disabled placeholder></el-input>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.type_report === 'month' ?  '': 'not_display']"
                            required
                          >
                            <el-date-picker
                              ref="month"
                              v-model="form.type_data.month"
                              style="width:100%;"
                              :default-value="defaultDate"
                              type="month"
                              clearable
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.type_report === 'between_month' ?  '': 'not_display']"
                            required
                          >
                            <el-date-picker
                              ref="monthfrom"
                              :default-value="defaultDate"
                              v-model="form.type_data.monthfrom"
                              style="width:40%;"
                              type="month"
                              clearable
                            ></el-date-picker>&nbsp;-&nbsp;
                            <el-date-picker
                              ref="monthto"
                              :default-value="defaultDate"
                              v-model="form.type_data.monthto"
                              style="width:40%;"
                              type="month"
                              clearable
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.type_report === 'year' ?  '': 'not_display']"
                            required
                          >
                            <el-date-picker
                              ref="year"
                              v-model="form.type_data.year"
                              style="width:100%;"
                              type="year"
                              :default-value="defaultDate"
                              clearable
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.type_report === 'between_year' ?  '': 'not_display']"
                            required
                          >
                            <el-date-picker
                              :default-value="defaultDate"
                              ref="yearfrom"
                              v-model="form.type_data.yearfrom"
                              type="year"
                            ></el-date-picker>&nbsp;&nbsp;-&nbsp;
                            <el-date-picker
                              :default-value="defaultDate"
                              ref="yearto"
                              v-model="form.type_data.yearto"
                              type="year"
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.type_report === 'quarter' ?  '': 'not_display']"
                            required
                          >
                            <el-select
                              style="width:50%;"
                              ref="quarter"
                              v-model="form.type_data.quarter"
                            >
                              <el-option label="1" value="1"></el-option>
                              <el-option label="2" value="2"></el-option>
                              <el-option label="3" value="3"></el-option>
                              <el-option label="4" value="4"></el-option>
                            </el-select>&nbsp;
                            <el-date-picker
                              v-model="form.type_data.quarter_year"
                              ref="quarter_year"
                              type="year"
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-if="form.type_report === 'between_quarter'"
                            v-bind:class="[form.type_report === 'between_quarter' ?  '': 'not_display']"
                            required
                          >
                            <el-select
                              style="width:20%;"
                              ref="quarterfrom"
                              v-model="form.type_data.quarterfrom"
                            >
                              <el-option label="1" value="1"></el-option>
                              <el-option label="2" value="2"></el-option>
                              <el-option label="3" value="3"></el-option>
                              <el-option label="4" value="4"></el-option>
                            </el-select>&nbsp;
                            <el-date-picker
                              style="width:25%;"
                              v-model="form.type_data.quarter_year_from"
                              ref="quarter_year_from"
                              type="year"
                            ></el-date-picker>&nbsp;&nbsp;-&nbsp;
                            <el-select
                              style="width:20%;"
                              ref="quarterto"
                              v-model="form.type_data.quarterto"
                            >
                              <el-option label="1" value="1"></el-option>
                              <el-option label="2" value="2"></el-option>
                              <el-option label="3" value="3"></el-option>
                              <el-option label="4" value="4"></el-option>
                            </el-select>&nbsp;
                            <el-date-picker
                              style="width:25%;"
                              v-model="form.type_data.quarter_year"
                              ref="quarter_year_to"
                              type="year"
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item label="ย่านความถี่">
                            <el-checkbox-group v-model="form.frequency" ref="frequency">
                              <el-checkbox label="900">900 MHz</el-checkbox>
                              <el-checkbox label="1800">1800 MHz</el-checkbox>
                              <el-checkbox label="2100">2.1 GHz</el-checkbox>
                              <el-checkbox label="other">อื่นๆ</el-checkbox>
                            </el-checkbox-group>
                          </el-form-item>
                          <el-form-item label="สถานะการให้บริการ">
                            <el-checkbox-group v-model="form.service_status">
                              <el-checkbox label="S">ประเภทบุคคลทั่วไป (รายการส่งเสริมการขายที่ยังขายอยู่)</el-checkbox><br/>
                              <el-checkbox label="U">ประเภทบุคคลทั่วไป (รายการส่งเสริมการขายที่ไม่ขายแล้ว แต่ยังให้บริการอยู่)</el-checkbox><br/>
                              <el-checkbox label="CS">ประเภทองค์กร (รายการส่งเสริมการขายที่ยังขายอยู่)</el-checkbox><br/>
                              <el-checkbox label="CU">ประเภทองค์กร (รายการส่งเสริมการขายที่ไม่ขายแล้ว แต่ยังให้บริการอยู่)</el-checkbox><br/>
                            </el-checkbox-group>
                          </el-form-item>
                        </div>
                      </div>
                    </el-form>
                    <div class="layout_filter_btn">
                      <button type="button" class="btn btn-primary" @click="find_chart()">ค้นหา</button>
                    </div>
                  </div>
                  <div v-if="displayChart&&showChart">
                    <div class="col-sm-12" style="text-align:right;">
                      <el-button type="primary" @click.prevent="exportDoc">Export Word </el-button>
                    </div>
                  </div>
                  <div id="chart" class="box-body" ref="chart" style="min-height: 500px;" v-if="displayChart&&showChart">
                    <div style="padding-top: 50px;" v-for="(chart,index) in store_charts" :key="index">
                      <charts class="chart" :options="chart" style="max-height : 400px;"></charts><br><br>
                    </div>
                  </div>
                  <div class="box-body" v-if="showDataNotFound">
                    <div class="col-sm-12">
                      <h4 align="center">ไม่พบข้อมูลการค้นหา</h4>
                    </div>
                 </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>
<script>
const moment = require("moment");
import Chart from "chart.js";
import { mapState, mapActions } from "vuex";
import jsPDF from "jspdf";
import { Document, Packer, Paragraph, Media, PageOrientation } from "docx";
import { saveAs } from "file-saver";
export default {
  data() {
    return {
      displayChart: false,
      showExport: null,
      textShow: "",
      type_providers: "on_service",
      defaultDate: "",
      dynamicDiv: [],
      mixedChart: null,
      label_position: "top",
      form: {
        type_providers: "group",
        service_status: ['S','U','CS','CU'],
        frequency: ["900","1800","2100"],
        type_data: {
          quarterfrom: null,
          quarterto: null,
          yearfrom: null,
          yearto: null,
          monthto: null,
          monthfrom: null,
          monthOfyear: null,
          month: null,
          year: null,
          quarter: null,
          quarter_year_from: null,
          quarter_year: null
        },
        provider_list: "",
        provider_group: "",
        major_service_providers: "",
        retail_service_provider: "",
        type_sele: "",
        type_report: "",
        year: "",
        quarter: ""
      },
      options: {
        pieceLabel: {
          render: function(args) {
            return args.label + " " + args.value + "%";
          },
          overlap: true,
          fontSize: 14,
          fontStyle: "bold",
          fontColor: "#FFF"
        }
      },
      data: {}
    };
  },
  created() {},
  mounted() {},
  beforeCreate(){
    this.$store.dispatch('Report_pmt/getGroupCompany','mobile')
    this.$store.dispatch('Report_pmt/getProviderByType','mobile')
  },
  computed: {
    ...mapState({
      store_charts : store => store.Report_PP.charts,
      store_groups : store => store.Report_pmt.provider_group,
      store_providers : store => store.Report_pmt.provider_list,
      showChart : store => store.Report_PP.showChart,
      showDataNotFound : store => store.Report_PP.showDataNotFound
    })
  },
  methods: {
    ...mapActions({
      searching : 'Report_PP/setChartData',
    }),
    checkProviders(type) {
      if (this.form.provider_group != "" && type == 2) {
        this.form.provider_list = "";
      } else if (this.form.provider_list != "" && type != 2) {
        this.form.provider_group = "";
      }
    },
    clear_data() {
      this.form.type_data = {
        quarterfrom: null,
        quarterto: null,
        yearfrom: null,
        yearto: null,
        monthfrom: null,
        monthto: null,
        month: null,
        monthOfyear: null,
        year: null,
        quarter: null,
        quarter_year_from: null,
        quarter_year: null
      };
    },
    switch_type() {
        this.form.provider_group = ''
        this.form.provider_list = ''
    },
    find_chart() {
      if (this.form.type_report == '') {
        this.$alert("กรุณาเลือกประเภทรายงาน", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.type_report.focus();
          }
        });
        return false;
      }else if(this.form.type_report == "between_month"){
         if(this.form.type_data.monthfrom == null){
            this.$alert("กรุณาเลือกระหว่างเดือน", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              callback: action => {
                this.$refs.monthfrom.focus();
              }
            });
            return false;
         }else if(this.form.type_data.monthto == null){
            this.$alert("กรุณาเลือกระหว่างเดือน", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              callback: action => {
                this.$refs.monthto.focus();
              }
            });
            return false;
         }
      }
      if (this.form.type_report == "year" && this.form.type_data.year == null) {
        this.$alert("กรุณาเลือกปี", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.year.focus();
          }
        });
        return false;
      }
      if ((this.form.type_report == "between_year" && this.form.type_data.yearfrom == null) || (this.form.type_report == "between_year" && this.form.type_data.yearto == null)) {
        this.$alert("กรุณาเลือกระหว่างปี", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            if (this.form.type_data.yearfrom == null) {
              this.$refs.yearfrom.focus();
            } else {
              this.$refs.yearto.focus();
            }
          }
        });
        return false;
      }
      if ( this.form.type_report == "quarter" && this.form.type_data.quarter == null ) {
        this.$alert("กรุณาเลือกไตรมาส", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.quarter.focus();
          }
        });
        return false;
      }else if(this.form.type_report == "quarter" && this.form.type_data.quarter_year == null ){
        this.$alert("กรุณาเลือกปี", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.quarter_year.focus();
          }
        });
        return false;
      }
      if(this.form.type_report == "between_quarter" && this.form.type_data.quarterfrom == null){
            this.$alert("กรุณาเลือกช่วงไตรมาส", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              callback: action => {
                this.$refs.quarterfrom.focus();
              }
            });
            return false;
      }else if(this.form.type_report == "between_quarter" && this.form.type_data.quarter_year_from == null){
          this.$alert("กรุณาเลือกปี", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              callback: action => {
                this.$refs.quarter_year_from.focus();
            }
          });
          return false;
      }else if(this.form.type_report == "between_quarter" && this.form.type_data.quarterto == null){
          this.$alert("กรุณาเลือกช่วงไตรมาส", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              callback: action => {
                this.$refs.quarterto.focus();
            }
          });
          return false;
      }else if(this.form.type_report == "between_quarter" &&this.form.type_data.quarter_year == null){
          this.$alert("กรุณาเลือกปี", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              callback: action => {
                this.$refs.quarter_year_to.focus();
            }
          });
          return false;
      }if(this.form.type_providers == "group" && this.form.provider_group == "") {
        this.$alert("กรุณาเลือกกลุ่มผู้ให้บริการ", "แจ้งเตือน", {
          confirmButtonText: "ตกลง"
        });
        return false;
      }else if(this.form.type_providers == "provider" && this.form.provider_list == "" ){
          this.$alert("กรุณาเลือกรายชื่อผู้ให้บริการ", "แจ้งเตือน", {
          confirmButtonText: "ตกลง"
        });
        return false;
      }
      if (this.form.service_status.length == 0) {
        this.$alert("กรุณาเลือกข้อมูลที่ต้องการ", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.service_status.focus();
          }
        });
        return false;
      }
      
      this.displayChart = true;
      let formdata = this.form
      formdata.list = this.form.type_providers == "group" ? this.store_groups.filter(item => this.form.provider_group == item.id) : this.store_providers.filter(item => this.form.provider_list == item.id)
      this.searching(formdata)
      this.showExport = true;
    },
    dashedBorder(myChart) {
      Chart.helpers.each(
        myChart.getDatasetMeta(0).data,
        function(rectangle, index) {
          rectangle.draw = function() {
            myChart.chart.ctx.setLineDash([0, 40]);
            Chart.elements.Rectangle.prototype.draw.apply(this, arguments);
          };
        },
        null
      );
    },
    generatePDF(dname) {
      var doc = new jsPDF("landscape");
      doc.internal.scaleFactor = 2.0;
      this.$html2canvas(this.$refs[dname], {
        canvas: null
      }).then(function(canvas) {
        const img = canvas.toDataURL("image/png");
        doc.addImage(img, "JPEG", 10, 10, 280, 150);
        doc.save("Report.pdf");
      });
    },
    exportDoc(){
      this.$html2canvas(this.$refs.chart, { canvas: null }).then(function(canvas) { console.log(canvas) })
      this.$html2canvas(this.$refs.chart, { 
        canvas: null, 
        onclone: function(clone) {
          clone.querySelector('.highcharts-root').style.width = '100%';
          clone.querySelector('.highcharts-root').style.height = 'auto';
          clone.querySelector('.highcharts-root').style.objectFit = 'cover';
        } 
      }).then(function(canvas) {
        const img = canvas.toDataURL("image/png", 1.0);
        const doc = new Document();
        let width = 920
        let height = width*(canvas.height/canvas.width)
        const image = Media.addImage(doc, img, width, height);
        doc.addSection({
          size: {
            orientation: PageOrientation.LANDSCAPE,
          },
          children: [new Paragraph(image)],
        });
        Packer.toBlob(doc).then(blob => {
          saveAs(blob, "report.docx");
        });
      });
    }
  }
};
</script>
<style scoped>
  .custom {
    font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
    border-collapse: collapse;
    width: 100%;
    margin-top: 30px;
  }

  .custom td,
  .custom th {
    border: 1px solid #ddd;
    padding: 8px;
  }

  .custom th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
  }
</style>